import React, { useContext, useState } from "react";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ContainerGoogle } from "./styles";
import { Input } from "../../Input";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";

type ModoIntegracao = "ga4" | "gtm";

export const Google: React.FC = () => {
  const { theme } = useTheme();
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);

  const [modo, setModo] = useState<ModoIntegracao>(
    configuracoes.dados_google.tag_manager ? "gtm" : "ga4"
  );

  const handleModoChange = (novoModo: ModoIntegracao) => {
    setModo(novoModo);
    setConfiguracoes({
      ...configuracoes,
      dados_google: {
        ...configuracoes.dados_google,
        analytics: novoModo === "ga4" ? configuracoes.dados_google.analytics : "",
        tag_manager: novoModo === "gtm" ? configuracoes.dados_google.tag_manager : "",
      },
    });
  };

  return (
    <ContainerGoogle theme={theme}>
      <div className="ga4-gtm-radios">
        <label className="modo-radio fonteTexto">
          <input
            type="radio"
            name="modoIntegracaoGoogle"
            checked={modo === "gtm"}
            onChange={() => handleModoChange("gtm")}
          />
          Google Tag Manager (GTM)
        </label>
        <label className="modo-radio fonteTexto">
          <input
            type="radio"
            name="modoIntegracaoGoogle"
            checked={modo === "ga4"}
            onChange={() => handleModoChange("ga4")}
          />
          Google Analytics (GA4)
        </label>
      </div>

      {modo === "ga4" && (
        <>
          <Input
            type="text"
            value={configuracoes.dados_google.analytics}
            placeholder="G-XXXXXXXXXX"
            maxLength={20}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_google: {
                  ...configuracoes.dados_google,
                  analytics: newValue,
                },
              });
            }}
          />
          <span className="modo-descricao">Os eventos serão enviados diretamente para o Google Analytics.</span>
        </>
      )}

      {modo === "gtm" && (
        <>
          <Input
            type="text"
            value={configuracoes.dados_google.tag_manager}
            placeholder="GTM-XXXXXX"
            maxLength={20}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_google: {
                  ...configuracoes.dados_google,
                  tag_manager: newValue,
                },
              });
            }}
          />
          <span className="modo-descricao">Os eventos serão enviados para o GTM. Configure o GA4 e outras tags dentro do painel do GTM.</span>
        </>
      )}
    </ContainerGoogle>
  );
};
